import { 
    LOOK_OUT_FOR_THE_LITTLE_GUYS_T_SHIRT, 
    GREEN_CREW,
    TURTLE_CROSSING_PIN,  
    Product
} from '../products';

const turtlRescueClubRecos: Product[] = [
    LOOK_OUT_FOR_THE_LITTLE_GUYS_T_SHIRT,
    GREEN_CREW,
    TURTLE_CROSSING_PIN,   
];

export default turtlRescueClubRecos;